import { getCompanyNameFromConfig } from '@/utils/appSettings'
import { getUserId} from'@/utils/helpers'

const userId = getUserId()
export default {
    isLoggedIn: !!userId && userId > 0,
    loading: false,
    token: !!sessionStorage.getItem("token"),
    layoutConfig: null,
    // {
    //   backgroundColor: "white",
    //   footerColor: "white",
    //   footerBackgroundColor: "black",
    //   footerFontSize: "24px",
    //   logo: "/logo.png",
    //   navbarBackgroundColor: "black",
    //   title: "QMS - WebReservation",
    //   titleColor: "white",
    //   titleSize: "28px"
    // },
    key: 1,
    baseFontSize: 18,
    contrast: "none",
    originalLayoutConfig: null,
    companyName: getCompanyNameFromConfig(),
    locales: {}
};
